export const paths = Object.freeze({
  dashboard: '/',
  partners: '/partners',
  agents: '/agents',
  adminUsers: '/admin-users',
  permissionProfiles: '/permission-profiles',
  members: '/members',
  affiliateWallets: '/affiliate-wallets',
  affiliateWithdrawals: '/affiliate-withdrawals',
  games: '/games',
  commissionRules: '/commission-rules',
  commissionLedger: '/commission-ledger',
  transactions: '/transactions',
  transactionFailures: '/transaction-failures',
  apiOperations: '/api-operations',
  reconciliation: '/reconciliation',
  partnerCredit: '/partner-credit',
  reports: '/reports/transactions',
  reportExports: '/report-exports',
  approvals: '/approvals',
  audit: '/audit',
  securityEvents: '/security-events',
  profile: '/profile',
} as const);
